// extracted by mini-css-extract-plugin
export default {"error_message":"ErrorMessage_error_message__NEkpc"};